import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { QuoteSummary } from '../models/quote-summary';
import { PlanSummariesByLineOfCoverage } from '../models/plan-summaries-by-loc';
import { Observable, BehaviorSubject } from 'rxjs';
import { SelectedPlan } from '../models/selected-plan';
import { oeresult } from '../models/oeresult';

@Injectable({
    providedIn: 'root'
})
export class CoreApiService {
    private quoteSummaryUrl = 'api/quoteData/quoteSummary/';
    private planSummaryUrl = 'api/quoteData/planSummaries/';
    private planSelectionUrl = 'api/quoteData/planSelection/';
    private planSelectionCompleteUrl = 'api/quoteData/planSelectionComplete/';
    private csrfTokenUrl = 'api/quoteData/GetAntiForgeryToken'
    private planEnrollmentUrl = 'api/quoteData/planEnrollment/';
    csrfToken: string='';
    private readonly headers: HttpHeaders;
    private readonly postHeaders: HttpHeaders;
    antiForgeryToken = new BehaviorSubject<string>('')
    constructor(private httpClient: HttpClient) {
        this.headers = new HttpHeaders().set(
            'Content-Type',
            'application/json'
        );
    }

    removeEncryptionSalt = (id) => {
        let decryptedId = id
            .split("")
            .reverse()
            .join("")
            .match(/.{1,32}/g) //The Encryption Salt is of 32bit. If AWS changes this length, we need to change here too.
            .reverse()
            .map((i) => i.split("").reverse().join(""));
        return decryptedId;
    };

    decryptedQuoteId(quoteId: string) {
        try {
            console.log("Processing in API Service while Decrypting QuoteId");
            var decryptedQuoteId = atob(decodeURIComponent(quoteId));
            return this.removeEncryptionSalt(decryptedQuoteId)[0];
        }
        catch {
            console.log("Error in API Service while Decrypting QuoteId");
        }        
    }

    decryptedEnrollmentId(enrollmentId: string) {
        try {
            console.log("Processing in API Service while Decrypting EnrollmentId");
            var decryptedenrollmentId = atob(decodeURIComponent(enrollmentId));
            return this.removeEncryptionSalt(decryptedenrollmentId)[0];
        }
        catch {
            console.log("Error in API Service while Decrypting EnrollmentId");
        }
        
    }

    setCsrf(token: string) {
        this.antiForgeryToken.next(token);
        this.getCsrf().subscribe({
            next: (token) => {
                this.csrfToken = token;
            },
            error: (error) => console.log(error)
        });
    }

    getCsrf() {
        return this.antiForgeryToken
    }
    getAuthHeaderForPost(): HttpHeaders {
        return new HttpHeaders({
            'xsrf-token': this.csrfToken
        });
    }
    public getQuoteSummary(
        quoteId: string,
        enrollmentId: string
    ): Observable<QuoteSummary> {
        return this.httpClient.get<QuoteSummary>(
            this.quoteSummaryUrl + quoteId + '/' + enrollmentId
        );
    }
    public getPlanSummaries(
        quoteId: string,
        enrollmentId: string
    ): Observable<PlanSummariesByLineOfCoverage[]> {
        return this.httpClient.get<PlanSummariesByLineOfCoverage[]>(
            this.planSummaryUrl + quoteId + '/' + enrollmentId
        );
    }
    public savePlanSelections(
        quoteId: string,
        enrollmentId: string,
        user: string,
        planSelections: SelectedPlan[]
    ): Observable<boolean> {
        return this.httpClient.post<any>(
            this.planSelectionUrl + quoteId + '/' + enrollmentId,
            { user, planSelections },
            { headers: this.getAuthHeaderForPost() }
        );
    }
    public getToken() {
        return this.httpClient.get(this.csrfTokenUrl, { responseType:'text' })
    }
    public setPlanSelectionComplete(
        quoteId: string,
        enrollmentId: string,
        user: string
    ): Observable<boolean> {
        return this.httpClient.post<boolean>(            
            this.planSelectionCompleteUrl + quoteId + '/' + enrollmentId,
            { user },
            { headers: this.getAuthHeaderForPost() }
        );
    }

    public startPlanEnrollment(
        quoteId: string,
        enrollmentId: string,
        user: string
    ): Observable<oeresult> {
        return this.httpClient.post <oeresult>(
            this.planEnrollmentUrl + quoteId + '/' + enrollmentId,
            { user },
            { headers: this.headers }
        );
    }

    public getQuote(
        quoteId: string
    ): Observable<boolean> {
        return this.httpClient.get<boolean>(
            this.quoteSummaryUrl + quoteId
        );
    }
}
